import Card from './Card'
import Meta from './Meta'
import Grid from './Grid'
Card.Meta = Meta
Card.Grid = Grid
export default Card



// WEBPACK FOOTER //
// ./components/card/index.js